import { EcsEndpoint } from '../EcsClientConstants';
function getBaseFluidEcsClientConfiguration(audience) {
    return {
        host: getEcsEndpoint(audience),
        clientName: 'Fluid',
        clientVersion: '0.0.0.1',
        teamNames: ['FluidExperiences']
    };
}
function getEcsEndpoint(audience) {
    switch (audience) {
        case 'Automation':
        case 'SyntheticTraffic':
        case 'Local':
        case 'Staging':
        case 'Dogfood':
        case 'Preview':
        case 'Microsoft':
        case 'Production':
            return EcsEndpoint.PUBLIC;
        case 'GCC':
            return EcsEndpoint.GCC;
        case 'GCC-High':
            return EcsEndpoint.GCCHigh;
        case 'DoD':
            return EcsEndpoint.DOD;
        default:
            throw new Error('Unexpected audience value provided');
    }
}
/**
 * Object used to change the setup of a `EcsClient`.
 */
const defaultResponsesCacheKey = 'FluidEcsClientResponses';
/**
 * Gets the `EcsClientConfiguration` which contains information about how to connect to an ECS account
 * and information about the current request, like filters.
 * @param ecsSettingsProviderConfiguration Configuration for the EscSettingsProvider.
 * @returns An `EcsClientConfiguration` object used to setup an `EcsClient`
 */
export function getFluidEcsClientConfiguration(ecsSettingsProviderConfiguration) {
    const userId = ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.id
        ? // Exception added when eslint rule was added, this should be revisited when modifying this code
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.id
        : ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.oid;
    const tenantId = ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.tenantId;
    const hostName = ecsSettingsProviderConfiguration.hostName;
    const filters = { audience: ecsSettingsProviderConfiguration.ecsFilters.audience, userId, tenantId, hostName };
    const sessionId = ecsSettingsProviderConfiguration.sessionId;
    const cacheKey = `${userId}${hostName}${ecsSettingsProviderConfiguration.ecsFilters.audience}`;
    const responsesCacheKey = ecsSettingsProviderConfiguration.responsesCacheKeyOverride || defaultResponsesCacheKey;
    const cacheExpiresDurationOverrideInMin = ecsSettingsProviderConfiguration.cacheExpiresDurationOverrideInMin;
    return {
        ...getBaseFluidEcsClientConfiguration(ecsSettingsProviderConfiguration.ecsFilters.audience),
        filters,
        cacheKey,
        responsesCacheKey,
        cacheExpiresDurationOverrideInMin,
        sessionId
    };
}
//# sourceMappingURL=EcsSettingsProviderUtilities.js.map